module.exports = __webpack_public_path__ + "static/media/sell_change_request_3-1.7d7a44c2.png";